module.exports = __webpack_public_path__ + "static/img/cont40_06.c316d3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont40_06.jpg
// module id = SCKM
// module chunks = 0